<mat-nav-list>
  <mat-list-item class="indicator-item">
    <app-sidebar-transfer-indicator
      [isExpanded]="isExpanded"
      [locatorStatus]="locatorStatus"
      (toggleTooltip)="toggleTooltip($event.event, $event.template)"
    ></app-sidebar-transfer-indicator>
  </mat-list-item>

  <mat-list-item (click)="onDeviceClick()" class="indicator-item">
    <app-device-registered-indicator [isExpanded]="isExpanded"></app-device-registered-indicator>
  </mat-list-item>
</mat-nav-list>
